const prefix = 'seru-admin';

export const cookies = {
  AUTH_TOKEN: `${prefix}.token`,
  HELP_DETAILS: `${prefix}.help-details`,
  PERMISSIONS: `${prefix}.permissions`,
  PERMISSIONS_IDS: `${prefix}.permissions-ids`,
  COURSES_SHOWCASE_ID: `${prefix}.courses-showcase-id`,
  INVOICE_ALREADY_OPENED_AT_FIRST_TIME: (invoiceId: string): string =>
    `${prefix}.invoice-${invoiceId}-already-opened-at-first-time`,
  DEFAULT_THEME: `${prefix}.default-theme`,
  USERNAME: `${prefix}.username`,
  CURRENT_ACCESS_ID: `${prefix}.current_access_id`,
  CURRENT_ACCESS_RESALE: `${prefix}.current_access_resale`,
};
